export default function SecondSub({ data }) {
	return (
		<div
			className={` 2xl:min-w-[1100px] xl:min-w-[900px] min-w-[800px]   top-5 py-8 px-4 absolute rtl:right-0    ltr:left-0  transition group-hover/sub:translate-y-5 translate-y-0 opacity-0 invisible group-hover/sub:opacity-100 group-hover/sub:visible duration-500 ease-in-out group-hover/sub:transform z-50  transform`}
		>
			<div className="  bg-shirinmehr-dark1 rounded-lg p-8   flex  flex-wrap gap-8 ">
				{data.map((item, index) => (
					<a
						key={index}
						className=" flex gap-3   items-center col-span-1  pb-2  text-white"
						href={item.link_data.link}
					>
						{false && (
							<div
								style={{ backgroundImage: `url(${item.photo})` }}
								className=" w-12 h-12  bg-no-repeat bg-contain  "
							></div>
						)}
						<div className="  flex justify-center  flex-col  ">
							<div className=" bg-white h-full w-1"></div>
							<div className="   flex gap-2  items-center ">
								<div className=" w-2 h-2 bg-white rounded-full "></div>{" "}
								<div> {item.title} </div>
							</div>
							{item.subTitle && (
								<div className=" text-xs flex whitespace-pre-line flex gap-2 items-center ">
									<div className=" w-2 h-2  rounded-full "></div>
									<div>{item.subTitle}</div>
								</div>
							)}
						</div>
					</a>
				))}{" "}
			</div>
		</div>
	);
}
